import React from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';
import ChangePayment from '../ChangePayment';
import Error from '../Error';

const Container = styled.div`
  padding: 20px 15px;
`;

const Text = styled.div`
  font-size: 1.4rem;
  color: ${colors.grey3};
  margin-bottom: 10px;
`;

export default function ChangePaymentMethodModal({ close }) {
  const [error, setError] = React.useState('');

  return (
    <Container>
      <Text>
        Please enter a new payment method
      </Text>
      <ChangePayment close={close} setError={setError} />
      {error
        && (
          <Error
            error={error}
            margin="20px 0px 0px 0px"
            position="relative"
          />
        )}
    </Container>
  );
}
